@switch (name) { @case ('drr-aaa-pin') {
<ng-container [ngTemplateOutlet]="aaaPin"></ng-container>
} }

<ng-template #aaaPin>
  <div
    [style.color]="active ? 'var(--aaa-color-tertiary)' : 'var(--aaa-color-dark)'"
  >
    <svg
      width="40"
      height="57"
      viewBox="0 0 40 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="20"
        cy="53"
        rx="18"
        ry="4"
        fill="var(--aaa-color-dark)"
        fill-opacity="0.3"
      />
      <path
        d="M32.7281 7.27211C36.0328 10.5764 37.9228 15.0363 37.9986 19.7089C38.0743 24.3815 36.3299 28.9004 33.1341 32.3101L20.0001 45L7.27211 32.7281C3.89644 29.3524 2 24.774 2 20.0001C2 15.2262 3.89644 10.6478 7.27211 7.27211C10.6478 3.89644 15.2262 2 20.0001 2C24.774 2 29.3524 3.89644 32.7281 7.27211Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="20" cy="20" r="17" fill="white" />
      <!-- aaa logo -->
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 18.4469C6 15.111 10.5273 12.3867 16.0916 12.3867C21.6882 12.3867 26.2154 15.111 26.2154 18.4469C26.2154 21.8141 21.6882 24.5377 16.0916 24.5377C10.5273 24.5377 6 21.8141 6 18.4469ZM11.7216 13.7339L13.64 20.0696L15.6514 12.9072C14.2361 12.9684 12.8838 13.244 11.7209 13.7339H11.7216ZM15.5577 16.3656L14.5192 20.0696H16.6256L15.5563 16.3656H15.5577ZM18.544 20.0696L20.368 13.6726C19.1039 13.1927 17.7627 12.9336 16.4061 12.9072L18.5447 20.0696H18.544ZM11.6902 20.0696L10.6531 16.3656L9.61524 20.0696H11.6909H11.6902ZM23.6688 20.8044C24.1719 20.1002 24.455 19.3042 24.455 18.4469C24.455 16.8249 23.4172 15.3865 21.7196 14.3455L23.6681 20.8037L23.6688 20.8044ZM21.5309 20.0696L20.4617 16.3656L19.4245 20.0696H21.5309ZM21.7511 20.8044H19.2044L18.9843 21.6005L19.5818 23.4974C20.508 23.2394 21.3805 22.8249 22.1592 22.2727L21.7511 20.8037V20.8044ZM12.6658 23.4974L11.911 20.8037H9.3951L9.17565 21.5692C10.0562 22.4264 11.2506 23.1 12.6651 23.528V23.4974H12.6658ZM16.8464 20.8037H14.2997L13.4821 23.7423C14.2997 23.926 15.1803 24.0178 16.0916 24.0178C16.6577 24.0178 17.1924 23.9872 17.727 23.8954L16.8464 20.8037V20.8037ZM10.3071 14.468C8.73467 15.4784 7.76045 16.8861 7.76045 18.4469C7.76045 19.3042 8.04349 20.0696 8.51522 20.7738L10.3071 14.468V14.468Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.8612 12.6623C34.0121 11.2539 29.5477 12.1725 23.9833 14.6518C24.2664 14.8661 24.5494 15.111 24.7689 15.356C29.0445 13.5802 32.346 13.0291 33.0378 14.1925C33.8234 15.5091 30.7106 18.7837 25.7123 22.0285L25.7752 22.0897C31.8742 18.2333 35.804 14.2537 34.8605 12.6623H34.8612ZM8.5153 27.9662C8.04357 27.1395 9.04924 25.5787 11.062 23.7117C10.9004 23.6745 10.7425 23.6232 10.5902 23.5587C10.5588 23.5587 10.5588 23.528 10.5588 23.528L10.0871 23.3443C7.66618 25.5175 6.44037 27.3538 7.00645 28.3336C7.69833 29.4657 10.6853 29.099 14.6779 27.66L14.6465 27.5988C11.4394 28.6704 9.08138 28.8847 8.516 27.9662"
        [attr.fill]="active ? 'var(--aaa-color-primary)' : 'var(--aaa-color-dark)'"
      />
      <!-- end of aaa logo -->
      <path
        d="M20 45L20 52"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </div>
</ng-template>
